import { render, staticRenderFns } from "./DyoProductEdit.vue?vue&type=template&id=627d67ae&"
import script from "./DyoProductEdit.vue?vue&type=script&lang=js&"
export * from "./DyoProductEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports